import { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { TitulacionLenta } from "./TitulacionLenta";

function App() {
	const [pesoInput, setPesoInput] = useState("");
	const [pesoCalculado, setPesoCalculado] = useState("");
	const titulacionRef = useRef(null);

	useEffect(() => {
		const root = document.getElementById("root");
		if (!root) return undefined;

		let lastHeight = 0;
		let animationFrameId;

		const measureContentHeight = () => {
			const rootHeight = Math.max(root.scrollHeight, root.getBoundingClientRect().height);
			const openModalDialog = document.querySelector(".modal.show .modal-dialog");

			if (!openModalDialog) return rootHeight;

			const modalStyles = window.getComputedStyle(openModalDialog);
			const modalMargins = (parseFloat(modalStyles.marginTop) || 0) + (parseFloat(modalStyles.marginBottom) || 0);
			return Math.max(rootHeight, openModalDialog.getBoundingClientRect().height + modalMargins);
		};

		const sendResize = () => {
			window.cancelAnimationFrame(animationFrameId);
			animationFrameId = window.requestAnimationFrame(() => {
				const height = Math.ceil(measureContentHeight());
				if (!Number.isFinite(height) || height <= 0 || height === lastHeight) return;

				lastHeight = height;
				window.parent.postMessage({ type: "resize", height }, "*");
			});
		};

		sendResize();
		window.addEventListener("load", sendResize);
		window.addEventListener("resize", sendResize);
		document.addEventListener("shown.bs.modal", sendResize);
		document.addEventListener("hidden.bs.modal", sendResize);

		let resizeObserver;
		if (typeof ResizeObserver !== "undefined") {
			resizeObserver = new ResizeObserver(sendResize);
			resizeObserver.observe(root);
		}

		return () => {
			window.cancelAnimationFrame(animationFrameId);
			window.removeEventListener("load", sendResize);
			window.removeEventListener("resize", sendResize);
			document.removeEventListener("shown.bs.modal", sendResize);
			document.removeEventListener("hidden.bs.modal", sendResize);
			if (resizeObserver) resizeObserver.disconnect();
		};
	}, []);

	const handleCalcular = () => {
		if (!pesoInput) return;
		setPesoCalculado(parseFloat(pesoInput));

		setTimeout(() => {
			titulacionRef.current?.scrollIntoView({ behavior: "smooth" });
		}, 100); 
	};

	const handlePesoKeyDown = (e) => {
		if (e.key !== "Enter") return;
		e.preventDefault();
		handleCalcular();
	};

	


	return (
		<>
			<div className="container mt-5 container-calc offset-lg-1 col-lg-10 offset-xl-2 col-xl-8 offset-xxl-3 col-xxl-6">
				<h5 className="d-block d-md-none mb-5 text-center medium-font txt-subtitle">
					Calcule <br /> la dosis de Treprostinil subcutáneo según el peso del paciente
					<img
						src="/images/icon-question.png"
						alt="Abrir información de cálculo"
						className="img-question"
						data-bs-toggle="modal"
						data-bs-target="#formulalentaModal"
					/>
				</h5>
				<h5 className="d-none d-md-block mb-4 text-center medium-font txt-subtitle">
					Calcule la dosis de Treprostinil subcutáneo según el peso del paciente
					<img src="/images/icon-question.png" alt="" className="img-question" data-bs-toggle="modal" data-bs-target="#formulalentaModal" />
				</h5>

				<p className="mb-4 text-center small-font leyenda">Este cálculo está con base en la recomendación de IPP Remodulin® autorizada en México de arrancar tratamiento con 1.25ng/kg/min</p>

				<div className="div-barra-blanca"></div>
				<div className="position-relative mt-2 mb-2 d-flex justify-content-between">
					
					<div>
						<small className="txt-name-element">Región</small>
						<div className="medium-font txt-content-element">México</div>
					</div>
					<div>
						<small className="txt-name-element">Presentación</small>
						<div className="medium-font txt-content-element">5mg/mL</div>
					</div>
					<div>
						<small className="txt-name-element">Titulación</small>
						<div className="medium-font txt-content-element">Según IPP</div>
					</div>
					<div className="d-md-none">
						<small className="txt-name-element"></small>
						<div className="txt-content-element"></div>
					</div>
					<div>
						<small className="txt-name-element"></small>
						<div className="txt-content-element"></div>
					</div>
				</div>
				<div className="mt-3 div-barra-blanca"></div>
				<div className="mt-4 pt-2 offset-md-3 col-md-6">
					<label htmlFor="pesoInput" className="form-label txt-label-input">
						PESO DEL PACIENTE (KG)
					</label>
					<input
						autoFocus
						id="pesoInput"
						type="text"
						className="mt-2 form-control form-input-weight"
						name="peso"
						value={pesoInput}
						placeholder="Ejemplo: 73.6"
						onChange={(e) => setPesoInput(e.target.value.replace(",", "."))}
						onKeyDown={handlePesoKeyDown}
					/>
					<p className="mt-2 txt-input-note">Usa “.” como separador decimal. Ejemplo: 73.6</p>
					<p className="mt-2 txt-input-note input-error d-none">Usa “.” como separador decimal. Ejemplo: 73.6</p>
				</div>

				<div className="text-center mt-4 pt-2 offset-md-4 col-md-4">
					<button onClick={handleCalcular} className="btn btn-success button-calculate">
						CALCULAR DOSIS
					</button>
				</div>

			
			</div>

			<div ref={titulacionRef}>
				{pesoCalculado && (
					<TitulacionLenta
						peso={pesoCalculado}
						region={1}
						regiones={[{ id: 1, nombre: "México", indexConcentraciones: 2 }]}
					/>
				)}
			</div>

			{/* MODAL - Formula lenta */}
			<div
				className="modal fade"
				id="formulalentaModal"
				tabIndex="-1"
				aria-labelledby="formulalentaModalLabel"
				aria-hidden="true"
				data-bs-backdrop="static"
				data-bs-keyboard="false">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div className="modal-body">
							<div className="text-center">
								<img src="/images/icon-drop.png" alt="" className="img-drop" />
								<h3 className="mb-0 txt-modal-title">¿Cómo se calcula la dosis de Treprostinil?</h3>
								<p className="d-none d-md-block mb-4 text-center small-font leyenda2" style={{ fontSize: "15px" }}>Este cálculo está con base en la recomendación de IPP Remodulin® autorizada en México de arrancar tratamiento con 1.25ng/kg/min</p>
								<p className="mb-0 mt-4 text-start txt-modal-p">Para calcular la dosis se aplica la siguiente fórmula:</p>
							</div>
							<div className="mt-4 row text-center div-formula">
								<div className="col-12  col-md-4">
									<p className="txt-modal-p d-block d-md-none">
										Velocidad de la infusión no diluida <br /> <span className="bold-font">(mL/L)</span>
									</p>
									<p className="txt-modal-p d-none d-md-block">
										Velocidad de la infusión no diluida <span className="bold-font">(mL/L)</span>
									</p>
								</div>
								<div className="col-12 col-md-1">
									<p className="txt-modal-p">=</p>
								</div>
								<div className="col-12 col-md-7">
									<p className="mb-2 txt-modal-p">
										Dosis <span className="bold-font">(mg/kg/min)</span> x Peso (kg) x 0.00006*
									</p>
									<div className="div-barra-gris"></div>
									<p className="mt-2 txt-modal-p d-block d-md-none">
										Concentración Frasco Ámpula <br /> Remodulin <span className="bold-font">(mg/mL)</span>
									</p>
									<p className="mt-2 txt-modal-p d-none d-md-block">
										Concentración Frasco Ámpula Remodulin <span className="bold-font">(mg/mL)</span>
									</p>
								</div>
								<div className="col-12">
									<p className="mb-0 txt-modal-ast d-block d-md-none">
										*Factor de conversión de 0.00006* = 60 <br /> min/hora x 0.000001 mg/ng
									</p>
									<p className="mb-0 txt-modal-ast d-none d-md-block">
										*Factor de conversión de 0.00006* = 60 min/hora x 0.000001 mg/ng
									</p>
								</div>
							</div>
							<div className="row">
								<div className="mt-4 col-12 col-md-6">
									<h5 className="mb-0 txt-modal-p bold-font">Ejemplo desglose de fórmula</h5>
									<p className="mb-0 txt-modal-p">1.25 ng/Kg/min x 72 Kg (dosis x peso) = 90 ng/min</p>
									<p className="mb-0 txt-modal-p">90 ng/min * 60 min/h (valor de hora) = 5400 ng/h</p>
									<p className="mb-0 txt-modal-p">5400 ng/h / 1000000 ng/mg (ng a mg) = 0.0054 mg/h</p>
									<p className="mb-0 txt-modal-p">0.0054 mg/h / 5 mg/mL (concentración del vial) = 0.00108 mL/h ≈ 0.001 mL/h</p>
									<br />
									<p className="mb-0 txt-modal-p">1mg tiene 1.000.000 ng</p>
								</div>
								<div className="mt-4 col-12 col-md-6">
									<h5 className="mb-0 txt-modal-p bold-font">Transformación de mL a UI</h5>
									<p className="mb-0 txt-modal-p">1mL = 100 UI</p>
									<p className="mb-0 txt-modal-p">0.00216 x 100 / 1 = 0.216 UI/h</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* /MODAL - Formula lenta*/}

			{/* MODAL - Formula intensificada */}
			<div
				className="modal fade"
				id="formulaintensificadaModal"
				tabIndex="-1"
				aria-labelledby="formulaintensificadaModalLabel"
				aria-hidden="true"
				data-bs-backdrop="static"
				data-bs-keyboard="false">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div className="modal-body">
							<div className="text-center">
								<img src="/images/icon-drop.png" alt="" className="img-drop" />
								<h3 className="mb-0 txt-modal-title">¿Cómo se calcula la dosis de Treprostinil?</h3>
								<p className="d-none d-md-block mb-4 text-center small-font leyenda2" style={{ marginTop: "-16px", fontSize: "15px" }}>Este cálculo está con base en la recomendación de IPP Remodulin® autorizada en México de arrancar tratamiento con 1.25ng/kg/min</p>
								<p className="mb-0 mt-4 text-start txt-modal-p">Para calcular la dosis se aplica la siguiente fórmula:</p>
							</div>
							<div className="mt-4 row text-center div-formula">
								<div className="col-12  col-md-4">
									<p className="txt-modal-p d-block d-md-none">
										Velocidad de la infusión no diluida <br /> <span className="bold-font">(mL/L)</span>
									</p>
									<p className="txt-modal-p d-none d-md-block">
										Velocidad de la infusión no diluida <span className="bold-font">(mL/L)</span>
									</p>
								</div>
								<div className="col-12 col-md-1">
									<p className="txt-modal-p">=</p>
								</div>
								<div className="col-12 col-md-7">
									<p className="mb-2 txt-modal-p">
										Dosis <span className="bold-font">(mg/kg/min)</span> x Peso (kg) x 0.00006*
									</p>
									<div className="div-barra-gris"></div>
									<p className="mt-2 txt-modal-p d-block d-md-none">
										Concentración Frasco Ámpula <br /> Remodulin <span className="bold-font">(mg/mL)</span>
									</p>
									<p className="mt-2 txt-modal-p d-none d-md-block">
										Concentración Frasco Ámpula Remodulin <span className="bold-font">(mg/mL)</span>
									</p>
								</div>
								<div className="col-12">
									<p className="mb-0 txt-modal-ast d-block d-md-none">
										*Factor de conversión de 0.00006* = 60 <br /> min/hora x 0.000001 mg/ng
									</p>
									<p className="mb-0 txt-modal-ast d-none d-md-block">
										*Factor de conversión de 0.00006* = 60 min/hora x 0.000001 mg/ng
									</p>
								</div>
							</div>
							<div className="row">
								<div className="mt-4 col-12 col-md-6">
									<h5 className="mb-0 txt-modal-p bold-font">Ejemplo desglose de fórmula</h5>
									<p className="mb-0 txt-modal-p">2.5x72 (dosis x peso) = 180 ng/min</p>
									<p className="mb-0 txt-modal-p">180*60 (valor de hora) = 10800 ng/hora</p>
									<p className="mb-0 txt-modal-p">10800/1000000 (ng a mg) = 0.0108 mg/hora</p>
									<p className="mb-0 txt-modal-p">0.0108/5mg = 0.00216 mL/hora</p>
									<br />
									<p className="mb-0 txt-modal-p">1mg tiene 1.000.000 ng</p>
								</div>
								<div className="mt-4 col-12 col-md-6">
									<h5 className="mb-0 txt-modal-p bold-font">Transformación de mL a UI</h5>
									<p className="mb-0 txt-modal-p">1mL = 100 UI</p>
									<p className="mb-0 txt-modal-p">00216x100/1 = 0.216 UI / Hora</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* /MODAL - Formula intensificada*/}
		</>
	);
}

export default App;
